import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-white/5 bg-carbon py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-212" data-mp="30isenak475qb">
      <div className="mx-auto max-w-4xl px-4" data-id="element-213" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-214" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-215" data-mp="39gb4cs8pe88j">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-snow" data-id="element-216" data-mp="35fiv3yzu03c9">
            Sunday at 11 p.m. Tomorrow you have geothermal energy class. And you're still searching for the best way to
            explain geothermal resources, drilling and well engineering, power generation technologies, and the role of
            geothermal energy in modern renewable systems without losing your students' attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-muted" data-id="element-217" data-mp="1k52dabkdqvkd">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-lava/20 bg-petrol p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-218" data-mp="x4i5ssm0o8xf">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-snow" data-id="element-219" data-mp="1c1iz30juwby0">
            <AlertTriangleIcon className="h-5 w-5 text-lava" aria-hidden="true" data-id="element-220" data-mp="1g3w39kiyg1so" />
            The real cost of not having the right materials:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-221" data-mp="3dv8jlw440i3y">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-222" data-mp="3hv0voispp6e2">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-lava" aria-hidden="true" data-id="element-223" data-mp="p0sj78sffyt3" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-224" data-mp="y1qdgzd2cryh">
          <p className="text-lg font-bold text-snow" data-id="element-225" data-mp="tzd8id654y2r">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 font-display text-3xl font-bold text-lava sm:text-4xl" data-id="element-226" data-mp="17ws1tszilq00">Plan your entire year today.</p>
        </div>
      </div>
    </section>;
}